
import { Button } from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export function HeroSection() {
  const navigate = useNavigate();
  return (
    <section className="relative min-h-screen flex items-center justify-center">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/banners/hero-stays.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-black/40" />

      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-7xl font-bold mb-6">
          Signature Collections
        </h1>
        <p className="text-xl md:text-2xl mb-8 leading-relaxed">
          Experience ultimate relaxation in luxury villas with private pools, elegant interiors,
          and breathtaking locations for your perfect getaway.
        </p>
        <Button
          onClick={() => navigate('/group-tours')}
          variant="primary"
          size="lg"
          className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-4 text-lg whitespace-nowrap"
        >
          Explore Collections
        </Button>
      </div>
    </section>
  );
}
